module.exports = "/_next/static/images/favicon-e5b903b17621aeebca1065d7d56aeeae.svg";